/*
 *  RefreshData mixin makes it simple to have a component kick off refreshing its data
 *  at the intervals when the ODS gets updated.
 *
 *  Presently the ODS updates every 20 minutes at :00, :20, :40.
 *  So this process kicks off refreshes at :02, :22, :42.
 *
 *  REFRESHMINUTES includes 62 just to help simplify the next-run math.
 *
 */

const REFRESHMINUTES = [
    2,
    22,
    42,
    62
];

export const RefreshData = {
    data() {
        return {refreshTimer: null};
    },
    methods: {
        setRefreshTimer(func) {
            const currentMinute = new Date().getMinutes();
            const nextMinute = REFRESHMINUTES.find(minute=>minute > currentMinute);
            // Number of minutes to next minute:
            const delayTilRefresh = (nextMinute - currentMinute) * 60 * 1000;
            // Random delay of a few seconds
            const randDelay = Math.floor(Math.random() * 20 * 1000);
            return setTimeout(func.bind(this), delayTilRefresh + randDelay);
        }
    },
    beforeDestroy() {
        // Clear timeout when component is being destroyed so it isn't run after its gone
        clearTimeout(this.refreshTimer);
    }
};